// @flow

import React from 'react';
import { LazyImage } from 'react-lazy-images';

type Props = {
  alt: String,
  src: String,
  placeHolderType: 'business' | 'business-cover' | 'post' | 'slider',
  className?: String,
};

export default (props: Props) => {
  return (
    <LazyImage
      className="user-select-none"
      src={props.src}
      alt={props.alt}
      {...props}
      placeholder={({ imageProps, ref }) => {
        return (
          <img
            ref={ref}
            src={`/assets/images/placeholder-${
              props.placeHolderType || 'post'
            }`}
            alt={imageProps.alt}
          />
        );
      }}
      actual={({ imageProps }) => <img alt={imageProps.alt} {...imageProps} />}
    />
  );
};
